export default "__VITE_ASSET__1c08a703__"